
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: "view-relate-flow",
components: {
Popup,
},
props: ['list'],
data() {
return {
showFlowItem: false,
}
},
methods: {
itemView(){
this.showFlowItem=true;
},
close(){
this.showFlowItem=false;
},
goRelateFlow(e){
this.$router.replace(`/workflow/${e.requestId}`);
}
},

}



// WEBPACK FOOTER //
// ./src/components/browse/view-relate-flow.vue